export const risks = ['Product & Tech Risks', 'Market Risks', 'Management Risks', 'Other Risks']

export default risks
